import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { AppProvider } from "@/context/AppContext";
import useLenis from "@/hooks/useLenis";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import WishlistDrawer from "@/components/WishlistDrawer";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Catalogue from "@/pages/Catalogue";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Payment from "@/pages/Payment";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import Account from "@/pages/Account";
import ProductDetail from "@/pages/ProductDetail";
import AuthCallback from "@/pages/AuthCallback";
import LegalPage from "@/pages/legal/LegalPage";
import CookieConsent from "@/components/CookieConsent";

const Page = ({ children }) => (
  <motion.main
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.5, ease: "easeInOut" }}
  >
    {children}
  </motion.main>
);

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Page><Home /></Page>} />
        <Route path="/catalogue" element={<Page><Catalogue /></Page>} />
        <Route path="/shop" element={<Page><Catalogue /></Page>} />
        <Route path="/product/:id" element={<Page><ProductDetail /></Page>} />
        <Route path="/account" element={<Page><Account /></Page>} />
        <Route path="/contact" element={<Page><Contact /></Page>} />
        <Route path="/about" element={<Page><About /></Page>} />
        <Route path="/legal/:slug" element={<Page><LegalPage /></Page>} />
        <Route path="/payment" element={<Page><Payment /></Page>} />
        <Route path="/payment/success" element={<Page><PaymentSuccess /></Page>} />
        <Route path="/payment/cancel" element={<Page><PaymentCancel /></Page>} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </AnimatePresence>
  );
}

function Shell() {
  useLenis();
  const location = useLocation();
  // Google OAuth returns to <origin>/account#session_id=... — process it first (playbook)
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  const isAdmin = location.pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <div className="noise-overlay" />}
      {!isAdmin && <Navbar />}
      <AnimatedRoutes />
      {!isAdmin && <Footer />}
      {!isAdmin && <CartDrawer />}
      {!isAdmin && <WishlistDrawer />}
      {!isAdmin && <CookieConsent />}
      <Toaster position="bottom-center" />
    </>
  );
}

export default function App() {
  return (
    <div className="App min-h-screen bg-paper text-ink">
      <BrowserRouter>
        <AppProvider>
          <Shell />
        </AppProvider>
      </BrowserRouter>
    </div>
  );
}
